import { Select, SelectItem } from '@wfp/react';
import React from 'react';

interface Props {
  selectedFilter: string;
  onFilterChange: (value: string) => void;
}

const CommentListFilterSet = ({ selectedFilter, onFilterChange }: Props) => {
  return (
    <div className="comment-filter-set">
      <Select
        id="acr-comment-filter-select"
        labelText=""
        value={selectedFilter}
        onChange={e => onFilterChange(e.target.value)}
        data-test-id="comments-filter-select"
      >
        <SelectItem value="all" text="All Comments" />
        <SelectItem value="opened" text="Open comments" />
        <SelectItem value="important" text="Important Comments" />
        <SelectItem value="owner" text="My comments" />
      </Select>
    </div>
  );
};

export default CommentListFilterSet;
